export default "__VITE_ASSET__CGZrvQ5E__"